import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import LdapIcon from "../../../assets/icons/ldap-01.svg2";
import FileUploadIcon from "../../../assets/icons/upload_file-01.svg2";
import GroupIcon from "../../../assets/icons/groups.svg2";
import CalenderIcon from "../../../assets/icons/calendar.svg2";
import LdapCredentialsForm from "./LdapCredentialsForm";
import ApiCredentialsForm from "./ApiCredentialsForm";
import ApiIcon from "../../../assets/icons/api_type-01.svg2";
import AssetsFound from "./AssetsFound";
import DataImportFound from "./DataImportFound";
import ContactsIcon from "../../../assets/icons/contacts_main.svg2";
import CalendarsFound from "./CalendarsFound";
import WaitingForData from "./GroupsWaitingForData";
import ApiWaitingForData from "./ApiWaitingForData";
import DragDropAFile from "./DragDropAFile";
import ContactsDataImportFound from "./ContactsDataImportFound";
import ImportOptions from "./ImportOptions";
import AssetIcon from "../../../assets/icons/asset-01.svg2";

const howToImportOptions = [
  {
    name: "ldap",
    heading: "LDAP(Lightweight Directory Access protocol)",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: LdapIcon,
  },
  {
    name: "file",
    heading: "File Upload(.ICS,.CSV)",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: FileUploadIcon,
  },
  {
    name: "api",
    heading: "Connect to new API",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: ApiIcon,
  },
];

const whatToImportOptions = [
  {
    name: "groups",
    heading: "Groups",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: GroupIcon,
  },
  {
    name: "calendar",
    heading: "Calendar",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: CalenderIcon,
  },
  {
    name: "asset",
    heading: "Asset",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: AssetIcon,
  },
  {
    name: "contacts",
    heading: "Contacts",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: ContactsIcon,
  },
];

function Import() {
  const [howtoImport, setHowtoImport] = useState(howToImportOptions[0]);
  const [whattoImport, setWhattoImport] = useState(whatToImportOptions[0]);

  return (
    <div>
      <Row className="mb-5 mt-3 m-5 ">
        <Col xs={4} lg={5} className="pe-5 border-end py-3">
          <ImportOptions
            howtoImport={howtoImport}
            setHowtoImport={setHowtoImport}
            whattoImport={whattoImport}
            setWhattoImport={setWhattoImport}
          />
        </Col>
        <Col xs={8} lg={7}>
          {howtoImport.name === "ldap" && <LdapCredentialsForm />}
          {howtoImport.name === "ldap" && <DataImportFound />}
          {howtoImport.name === "ldap" && <WaitingForData />}
          {howtoImport.name === "api" && <ApiWaitingForData />}
          {howtoImport.name === "api" && <ApiCredentialsForm />}
          {howtoImport.name === "file" && <DragDropAFile />}
          {whattoImport.name === "asset" && <AssetsFound />}
          {whattoImport.name === "contacts" && <ContactsDataImportFound />}
          {whattoImport.name === "calendar" && <CalendarsFound />}
        </Col>
      </Row>
    </div>
  );
}

export default Import;
